import * as React from 'react';
import type { IAppShellUserContentProps } from '../appshelluser';
import { AppShellHeaderActionButton } from '../appshellheaderactionbutton';
import { getArticlesCount, getEventsCount } from '@@modules/admin/api/inwinkconnect';
import type {ItemPromise} from '@inwink/modals/popovermgr';
import { getSetting, setSetting } from '@@services/usersettings';
import { craftAssetUrl } from '@@services/assetservice';

const inwinkConnectSetting = "inconnectstatus";
export interface IInwinkConnectNotificationProps extends IAppShellUserContentProps {

}

export interface IInwinkConnectNotificationState {
    badgeCount: number;
    hasInwinkConnect: boolean;
}

export interface IInwinkConnectStatus {
    date: string;
}

export class InwinkConnectNotification extends React.Component<IInwinkConnectNotificationProps, IInwinkConnectNotificationState> {
    popover: ItemPromise<any>;

    constructor(props) {
        super(props);

        this.state = {
            badgeCount: 0,
            hasInwinkConnect: !!(inwink.config?.inwinkconnect?.url)
        };
    }
    
    componentDidMount(): void {
        if (this.state.hasInwinkConnect) {
            this.loadArticles();
        }
    }

    loadArticles() {
        return getSetting(inwinkConnectSetting).then((statusStr) => {
            const filters: any = {};
            if (statusStr) {
                const status = JSON.parse(statusStr);
                const syncDate = new Date(status.date);
                filters.publishedAt = { $gt: syncDate.toISOString()};
            }

            return Promise.all([
                getArticlesCount({ filters }),
                getEventsCount({ filters: Object.assign({}, filters, {
                    startDate: {
                        $gt: new Date().toISOString()
                    }
                }) })
            ]).then((counts) => {
                const totalCount = counts[0] + counts[1];
                this.setState({ badgeCount:  totalCount });
            });
        }).then(null, (err) => {
            console.error("error loading articles", err);
        });
    }

    showInwinkConnect = (arg?: React.MouseEvent<any>) => {
        if (arg && arg.preventDefault) {
            arg.preventDefault();
            arg.stopPropagation();
        }
        
        return import("./modal").then((mod) => {
            this.popover = this.props.popovermgr.popoverPortal(this.props.parent || arg.target as HTMLElement,
                mod.InwinkConnectModal, this.props, "appshellinwinkconnectpopover");
            
            getSetting(inwinkConnectSetting).then((statusStr) => {
                let status: IInwinkConnectStatus = { date: new Date().toISOString() };
                if (statusStr) {
                    status = Object.assign({}, JSON.parse(statusStr), status);
                }
                setSetting(inwinkConnectSetting, JSON.stringify(status));
            }, (err) => console.error("error getting setting", err));

            this.setState({ badgeCount: 0 });
            this.popover.then(() => {
                this.popover = null;
            });

            this.props.afterClick();
        });
        
    };

    render() {
        if (!this.state.hasInwinkConnect) {
            return null;
        }

        return <AppShellHeaderActionButton
            iconUrl={craftAssetUrl("/assets/inwink/FAVICON_FULLWHITE.svg")}
            title="inwinkconnect.title"
            className="toggleNotifications inwinkconnect"
            badge={this.state?.badgeCount}
            onClick={this.showInwinkConnect}
        />;
    }
}